import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../Helpers/API";
import {
  Autocomplete,
  Button,
  Modal,
  Box,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { GetKey } from "../../../Helpers/GetKey";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';

export const AgregarLineaModal = ({ open, onClose }) => {

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [linea, setLinea] = useState({
    departamento: "",
    descripcion: "",
    estatus: true,
    imagen: null
  });
  const [departamentos] = useState([
    { id: 1, display: "Maquinaria Nueva" },
    { id: 2, display: "Refacciones" },
    { id: 3, display: "Servicio" },
    { id: 11, display: "Productos Aliados" },
    { id: 13, display: "Sistemas de Riego" },
    { id: 12, display: "Ferreteria" },
    { id: 14, display: "AMS" },
    { id: 16, display: "Drones" },
    { id: 24, display: "Maquinaria Usada" },
  ]);


  const fileInputRef = useRef(null);

  console.log(linea)
  const GetFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formatosValidos = ["jpg", "jpeg", "png"];
    const extension = file.name.split(".").pop().toLowerCase();

    if (!formatosValidos.includes(extension)) {
      Swal.fire("Nueva Línea", "Formato de archivo no válido", "error");
      event.target.value = "";
      return;
    }

    const fReader = new FileReader();
    fReader.readAsDataURL(file);
    fReader.onloadend = function (e) {
      const nuevaImagen = e.target.result;
      setLinea((prev) => ({ ...prev, imagen: nuevaImagen }));
    };
  };


  //Funciones de selector de imagenes
  const abrirSelector = () => fileInputRef.current?.click();

  const eliminarImagen = () => {
    setLinea((prev) => ({ ...prev, imagen: null }));
  };

  const guardarLinea = () => {
    if (
      linea.descripcion === "" ||
      linea.descripcion === null ||
      linea.descripcion === undefined
    ) {
      Swal.fire({
        title: "LINEAS DE VENTA",
        text: "Debe escribir una descripción para la linea",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    if (
      linea.descripcion === "" ||
      linea.descripcion === null ||
      linea.descripcion === undefined
    ) {
      Swal.fire({
        title: "LINEAS DE VENTA",
        text: "Debe seleccionar el departamento de la linea de venta",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    if (
      linea.imagen === "" ||
      linea.imagen === null ||
      linea.imagen === undefined
    ) {
      Swal.fire({
        title: "LINEAS DE VENTA",
        text: "Debe añadir una imagen para linea de venta",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    const iddepartamento = GetKey(linea.departamento);

    const post = {
      idlinea: 0,
      descripcion: linea.descripcion,
      departamento: iddepartamento,
      imagen: linea.imagen
    };

    setLoader({ ...loader, mostrar: true });
    request
      .post(`ListadoLineasVenta/AgregarLinea`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        onCerrar()
        await Swal.fire({
          title: "LINEA DE VENTA",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        setLinea({ ...linea, descripcion: "", departamento: "" });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("LINEAS DE VENTA", JSON.stringify(error), "error");
      });
  };

  const onCerrar = () => {
    setLinea({
      ...linea,
      id: 0,
      descripcion: "",
      departamento: "",
      estatus: false,
      imagen: ""
    })
    onClose()
  }

  return (
    <>
      <Modal open={open} onClose={onCerrar}>
        <div className="lineas-venta-modal-formulario">
          <div className="lineas-venta-modal-plantilla">
            <div
              className="plantilla-screen-filtro-container"
              id="mdlFiltros-modal"
            >
              <PlantillaScreen
                titulo={"AGREGAR LINEA DE VENTA"}
                className_main={1}
                className={"plantilla-screen-filtro-container-modal"}
              >
                <div className="cerrar-modal-button" onClick={onCerrar}>
                  X
                </div>
                <div className={`lineas-venta-modal-agregar-convenio`}>
                  <div className="lineas-venta-modal-agregar-convenio-container">
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="departamento"
                      freeSolo
                      className="w-66"
                      value={linea.departamento}
                      onChange={({ target }) =>
                        setLinea({ ...linea, departamento: target.outerText })
                      }
                      options={departamentos.map(
                        (option) => `${option.id} - ${option.display}`
                      )}
                      renderInput={(params) => (
                        <TextField {...params} label="Departamento" />
                      )}
                      sx={{ mt: 2 }}
                    />
                    {/* <h3 className="titulo-seccion">Registrar Linea de Venta</h3> */}
                    <TextField
                      id="outlined-multiline-static"
                      label="Linea"
                      sx={{ mt: 2 }}
                      size="small"
                      value={linea.descripcion}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^[a-zA-Z0-9ñÑ., ]*$/;

                        if (regex.test(value)) {
                          setLinea({
                            ...linea,
                            descripcion: e.target.value,
                          });
                        }
                      }}
                    />
                  </div>
                  <div className="imagenes-section">
                    <div className="titulos-imagenes-section">
                      <span><b>Imagen de la línea</b></span>
                      <span className="titulo-derecha">Solo 1 imagen permitida</span>
                    </div>

                    <div className="imagenes-group">
                      <div
                        className="imagen-button"
                        onClick={() => !linea.imagen && abrirSelector()}
                      >
                        {linea.imagen ? (
                          <>
                            <img
                              className="imagen-cargada"
                              src={linea.imagen}
                              alt="imagen-linea"
                            />
                            <DeleteIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                eliminarImagen();
                              }}
                              style={{
                                position: "absolute",
                                top: 2,
                                right: 2,
                                color: "red",
                                backgroundColor: "white",
                                borderRadius: "50%",
                                fontSize: "1.2rem"
                              }}
                            />
                          </>
                        ) : (
                          <AddPhotoAlternateIcon style={{ fontSize: 40, color: "#bbb" }} />
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          ref={fileInputRef}
                          onChange={GetFile}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="lineas-venta-modal-buttons">
                    <button
                      className="lineas-venta-modal-button-guardar"
                      onClick={() => guardarLinea()}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </PlantillaScreen>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
